// era-shop theme JS
(function() {
  'use strict';
  // Mobile menu toggle
  const mobileBtn = document.getElementById('mobileMenuBtn');
  const mobileNav = document.getElementById('mobileNav');
  if (mobileBtn && mobileNav) {
    mobileBtn.addEventListener('click', function() {
      const isOpen = mobileNav.classList.toggle('era-mobile-nav--open');
      mobileBtn.setAttribute('aria-expanded', isOpen);
    });
  }
  // Product filter tabs
  const filterTabs = document.querySelectorAll('.era-filter-tab');
  const productCards = document.querySelectorAll('.era-product-card');
  if (filterTabs.length && productCards.length) {
    filterTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        filterTabs.forEach(function(t) { t.classList.remove('era-filter-tab--active'); });
        tab.classList.add('era-filter-tab--active');
        const filter = tab.getAttribute('data-filter');
        productCards.forEach(function(card) {
          const category = card.getAttribute('data-category') || '';
          if (filter === 'all' || category === filter || category.includes(filter)) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }
  // Product page thumbnail switcher
  const thumbBtns = document.querySelectorAll('.era-thumb-btn');
  const mainImg = document.querySelector('.era-product-page__img');
  if (thumbBtns.length && mainImg) {
    thumbBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        thumbBtns.forEach(function(b) { b.classList.remove('era-thumb-btn--active'); });
        btn.classList.add('era-thumb-btn--active');
        const newSrc = btn.getAttribute('data-src');
        const newAlt = btn.getAttribute('data-alt');
        if (newSrc) { mainImg.src = newSrc; if (newAlt) mainImg.alt = newAlt; }
      });
    });
  }
})();